import { render, staticRenderFns } from "./RatingComponent.vue?vue&type=template&id=736751fa&"
import script from "./RatingComponent.vue?vue&type=script&lang=js&"
export * from "./RatingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports